import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as homeActions from '../../redux/homeActions';
import * as fabricCanvasActions from '../../redux/fabricCanvasActions';
import { bindActionCreators } from 'redux';
import FinalCheck from './FinalCheck/FinalCheck';
import VanillaFinalCheck from '../../components/VanillaDesign/VanillaFinalCheck/VanillaFinalCheck';
import './Body.scss';
import * as Constants from '../../utilities/constants/Constants';
import * as pageControllerActions from '../../redux/pageControllerActions';
import * as modalActions from '../../redux/modalActions';
import * as helperFunctions from '../../utilities/HelperFunctions/HelperFunctions';
import * as gaHelpers from '../../utilities/GAHelpers/GAHelpers';
import RipSelection from '../../components/RipSelection/RipSelection';
import Processing from '../../components/Processing/Processing';
import PostersDone from '../../components/PostersDone/PostersDone';
import ModelComponent from './ModelComponent/ModelComponent';
import DesignComponent from './DesignComponent/DesignComponent';

class Body extends Component {
  componentDidMount() {
    const { dispatchers, selectedProduct } = this.props;
    dispatchers.gaHelpers.sendDesignerLaunchGAEvents();
    dispatchers.pageControllerActions.setUpPages();
    const isSignageSuite = helperFunctions.isSignageSuiteProduct();
    if (isSignageSuite && selectedProduct === null) {
      dispatchers.modalActions.checkForSingleProduct();
    }
  }

  componentDidUpdate(prevProps) {
    const { selectedProduct, page, sendGA, dispatchers, language } = this.props;
    const isSignageSuite = helperFunctions.isSignageSuiteProduct();
    if (prevProps.page !== page) {
      if ((isSignageSuite && selectedProduct) || !isSignageSuite) {
        if (sendGA) {
          dispatchers.gaHelpers.gaOfPageChange(page);
        }
      }
    }
    if (prevProps.language !== language) {
      dispatchers.pageControllerActions.setUpPages();
    }
  }

  shouldDisplayHomePage = applySizeThroughUrl => {
    const {
      selectedProduct,
      page,
      projectWidth,
      projectHeight,
      isVanilla
    } = this.props;

    let signageSizeSelectionPage = false;
    if (
      selectedProduct &&
      selectedProduct.constraintType == Constants.CONSTRAINT_TYPE_CUSTOM &&
      !projectWidth &&
      !projectHeight
    ) {
      signageSizeSelectionPage = true;
    }

    let wallartSizeSelectionPage = false;
    if (
      !projectWidth &&
      !projectHeight &&
      !isVanilla &&
      !applySizeThroughUrl &&
      helperFunctions.isModelPage(page)
    ) {
      wallartSizeSelectionPage = true;
    }
    if (signageSizeSelectionPage || wallartSizeSelectionPage) {
      return true;
    }
    return (
      !selectedProduct &&
      helperFunctions.isModelPage(page) &&
      !applySizeThroughUrl
    );
  };

  shouldDisplayDesignPage = () => {
    const { page, progressData } = this.props;
    return page === Constants.DESIGN_PAGE && progressData <= 100;
  };

  shouldDisplayReviewOrderPage = () => {
    const { page, isVanilla } = this.props;
    return page === Constants.FINAL_CHECK_PAGE && !isVanilla;
  };

  shouldDisplayVanillaPrintPage = () => {
    const { page, isVanilla } = this.props;
    return (
      (page === Constants.FINAL_CHECK_PAGE || page === Constants.PRINT_PAGE) &&
      isVanilla
    );
  };

  shouldDisplayInitialPrintPage = () => {
    const { page, isVanilla } = this.props;
    return page === Constants.INITIAL_PRINT_PAGE && isVanilla;
  };

  shouldDisplayFileProcessingPage = () => {
    const { page, isVanilla } = this.props;
    return page === Constants.FILE_PROCESSING_PAGE && isVanilla;
  };

  shouldDisplayDesignSharePage = () => {
    const { page, isVanilla } = this.props;
    return page === Constants.DESIGN_SHARE_PAGE && isVanilla;
  };

  render() {
    const {
      progressData,
      envData,
      dispatchers,
      isVanilla,
      page,
      storeId
    } = this.props;

    let applySizeThroughUrl = false;
    const colorString = `#${Constants.NORMAL_WALL_COLOR}`;

    if (isVanilla && page === 0 && progressData === 100) {
      dispatchers.homeActions.setDefaultWallVanilla();
      dispatchers.pageControllerActions.setCurrentPageIndex(
        Constants.DESIGN_PAGE
      );
    }

    if (dispatchers.modalActions.isApplicationSizeFromURL() && page < 3) {
      applySizeThroughUrl = true;
      dispatchers.homeActions.setSizeFromApplicationUrl(
        envData.product_width,
        envData.product_height
      );
    }
    if (this.shouldDisplayHomePage(applySizeThroughUrl)) {
      return (
        <div style={{ backgroundColor: colorString }}>
          <ModelComponent />
        </div>
      );
    }

    if (this.shouldDisplayDesignPage()) {
      return (
        <>
          <DesignComponent />
        </>
      );
    }

    if (this.shouldDisplayReviewOrderPage()) {
      return (
        <>
          <FinalCheck />
        </>
      );
    }

    if (this.shouldDisplayVanillaPrintPage()) {
      return (
        <>
          <VanillaFinalCheck />
        </>
      );
    }

    if (this.shouldDisplayInitialPrintPage()) {
      return (
        <>
          <RipSelection storeId={storeId} />
        </>
      );
    }

    if (this.shouldDisplayFileProcessingPage()) {
      return (
        <>
          <Processing />
        </>
      );
    }

    if (this.shouldDisplayDesignSharePage()) {
      return (
        <>
          <PostersDone createNew={dispatchers.homeActions.createNewProject} />
        </>
      );
    }
    return null;
  }
}

function mapStateToProps(state) {
  return {
    progressData: state.modal.progressData,
    projectWidth: state.home.projectWidth,
    projectHeight: state.home.projectHeight,
    productSizes: state.modal.productSizes,
    language: state.home.language,
    page: state.pageController.currentPageIndex,
    isVanilla: state.modal.envData.is_vanilla_designer,
    wallSize: state.modal.productSizes.default.sizes,
    storeId: state.modal.storeData.id,
    category: state.modal.envData.category,
    customWidth: state.home.customWall.customWidth,
    customHeight: state.home.customWall.customHeight,
    envData: state.modal.envData,
    projectGroupId: state.finalCheck.project.projectGroupId,
    selectedProduct: state.home.selectedProduct,
    storeData: state.modal.storeData,
    sendGA: state.fabricCanvas.sendReviewGA
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatchers: {
      homeActions: bindActionCreators(homeActions, dispatch),
      fabricCanvasActions: bindActionCreators(fabricCanvasActions, dispatch),
      pageControllerActions: bindActionCreators(
        pageControllerActions,
        dispatch
      ),
      modalActions: bindActionCreators(modalActions, dispatch),
      helperFunctions: bindActionCreators(helperFunctions, dispatch),
      gaHelpers: bindActionCreators(gaHelpers, dispatch)
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Body);
